export default "__VITE_ASSET__BzTBV5qR__"